import React, { useState, useEffect } from "react";
import Signup from "../../screens/SignUp/index";
import ERRORS from "../../constants/errors";
import {
  validatePassword,
  handleSignUp,
  resendConfirmationCode,
} from "../../helper";
import { Modal } from "react-bootstrap";

function SignUpModal(props) {
  const {
    showSignup,
    closeSignupModal,
    user,
    address,
    getLoggedInDetails,
    resendSignupVerification,
    showAlert,
    cancelPlaceOrder,
    isStorePickup,
    openLoginModal,
    handleFormInputChange,
    completeSocialSignup,
    setCompleteSocialSignup,
    verifyPhoneNumber,
    setVerifyPhoneNumber,
    handleLogout,
    isMobile,
  } = props;

  const { email, given_name, username } = user;
  const [showOTP, setShowOTP] = useState(true);

  const handleSubmitSignUp = async () => {
    const password =
      given_name.toUpperCase().substring(0, 4) +
      String(username).substring(String(username).length - 4);
    return validatePassword(password)
      ? await handleSignUp(
          username,
          given_name,
          email,
          JSON.stringify(isStorePickup ? [] : [address]),
          password
        )
          .then((result) => result && setShowOTP(result))
          .then(() => showAlert("Signup", "OTP sent successfully", true))
          .catch((error) => {
            closeSignupModal();
            cancelPlaceOrder();
            showAlert("Signup", `${error.message}. Please try again.`);
          })
      : showAlert("Signup", ERRORS.PASSWORD_POLICY_MISMATCH);
  };

  const handleUserNotConfirmed = async () =>
    await resendConfirmationCode(username);

  useEffect(() => {
    if (showSignup && !showOTP && username) {
      resendSignupVerification
        ? handleUserNotConfirmed()
            .then((result) => {
              if (result) {
                setShowOTP(result);
                showAlert("Signup", "OTP sent successfully", true);
              }
            })
            .catch((error) => {
              cancelPlaceOrder();
              closeSignupModal();
              showAlert("Confirm Signup", error.message);
            })
        : handleSubmitSignUp();
    }
  });
  return (
    <Modal
      show={showSignup && showOTP}
      className="login-modal"
      onHide={() => {
        closeSignupModal();
        cancelPlaceOrder();
        showOTP && setShowOTP(false);
        completeSocialSignup && handleLogout();
      }}
      centered={!isMobile}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {completeSocialSignup ? "Complete Social Signup" : "Signup"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Signup
          given_name={given_name}
          username={username}
          closeSignupModal={closeSignupModal}
          getLoggedInDetails={getLoggedInDetails}
          setShowOTP={setShowOTP}
          resendSignupVerification={resendSignupVerification}
          showAlert={showAlert}
          email={email}
          openLoginModal={openLoginModal}
          handleFormInputChange={handleFormInputChange}
          completeSocialSignup={completeSocialSignup}
          setCompleteSocialSignup={setCompleteSocialSignup}
          verifyPhoneNumber={verifyPhoneNumber}
          setVerifyPhoneNumber={setVerifyPhoneNumber}
          isMobile={isMobile}
        />
      </Modal.Body>
    </Modal>
  );
}

const areEqual = (prevProps, nextProps) =>
  prevProps.showSignup === nextProps.showSignup &&
  prevProps.resendSignupVerification === nextProps.resendSignupVerification &&
  prevProps.user === nextProps.user &&
  JSON.stringify(prevProps.address) === JSON.stringify(nextProps.address);

export default React.memo(SignUpModal, areEqual);
